// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__klSdq","LoaderContainer":"Loader_LoaderContainer__MXFBV","LoaderShap":"Loader_LoaderShap__Vj81s","load_shap":"Loader_load_shap__89hpM"};